export const isChildNode =
  (classes: string[], exact = true) =>
  (element: HTMLElement): boolean => {
    if (element.tagName === 'body') {
      return false;
    }
    if (
      classes.some((c) =>
        exact
          ? element.classList.contains(c)
          : Array.from(element.classList).some((x) => x.includes(c)),
      )
    ) {
      return true;
    }

    if (element.parentElement == null) {
      return false;
    }

    return isChildNode(classes, exact)(element.parentElement);
  };
